module.exports = __webpack_public_path__ + "static/img/icon-plane.074b6c2f.svg";